<div class="full-width">
	<div #textContainer>
		<p
			*ngIf="isCollapsed"
			[ngClass]="{ line_clamp: isCollapsed }"
			class="text_container {{ textClass }}"
			[ngStyle]="{
				'-webkit-line-clamp': totalNumberOfLineToDisplay,
				'line-height': lineHeight + 'px !important'
			}"
		>
			{{ text }}
		</p>
		<p
			*ngIf="!isCollapsed"
			[ngClass]="{ line_clamp: isCollapsed }"
			class="text_container"
			[ngStyle]="{
				'-webkit-text-fill-color': textColor
			}"
		>
			{{ text }}
		</p>
	</div>

	<div
		(click)="isCollapsed = !isCollapsed"
		*ngIf="isShowReadMoreButton"
		class="link-primary font-size-14"
		fxLayoutAlign="end center"
	>
		Read {{ isCollapsed ? 'more' : 'less' }}
	</div>
</div>
